const templateResolveMap = new Map<string, (template: string) => void>();
const templatePromiseMap = new Map<string, Promise<string>>();

export function getModalTemplate(modalName: string): Promise<string> {
  if (!templatePromiseMap.has(modalName)) {
    const promise = new Promise<string>(function (resolve) {
      templateResolveMap.set(modalName, resolve);
    });
    templatePromiseMap.set(modalName, promise);
  }

  return templatePromiseMap.get(modalName);
}

export function resolveModalTemplate(modalName: string, args: { template: string }): void {
  if (!templateResolveMap.has(modalName)) {
    templatePromiseMap.set(modalName, Promise.resolve<string>(args.template));
  } else {
    templateResolveMap.get(modalName)(args.template);
  }
}
